import {
  generalArbitrageSettingsSchema,
  IArbitrageCexPairSettings,
  IArbitrageDexPairSettings,
  IArbitrageGeneralSettings,
  pairCexArbitrageSettingsSchema,
  pairDexArbitrageSettingsSchema,
} from 'types/arbitrage';
import { ICexPairShort, IDexPairShort } from 'types/pairs';

export const validateSelectedCexPairs = (selectedCexPairs: ICexPairShort[]) => {
  if (selectedCexPairs?.length === 0) {
    return {
      success: false,
    };
  }

  return { success: true };
};

export const validateSelectedDexPairs = (selectedDexPairs: IDexPairShort[]) => {
  if (selectedDexPairs?.length === 0) {
    return {
      success: false,
    };
  }

  return { success: true };
};

export const validateCexPairSettings = (pairForm: IArbitrageCexPairSettings) => {
  try {
    const validationSchema = pairCexArbitrageSettingsSchema;

    validationSchema.validateSync(pairForm, { abortEarly: false });

    return { success: true };
  } catch (e) {
    return { success: false };
  }
};

export const validateDexPairSettings = (pairForm: IArbitrageDexPairSettings) => {
  try {
    const validationSchema = pairDexArbitrageSettingsSchema;

    validationSchema.validateSync(pairForm, { abortEarly: false });

    return { success: true };
  } catch (e) {
    return { success: false };
  }
};

export const validateGeneralSettings = (settings: Partial<IArbitrageGeneralSettings>) => {
  const validationSchema = generalArbitrageSettingsSchema;

  try {
    validationSchema.validateSync(settings, { abortEarly: false });

    return { success: true };
  } catch (e) {
    return { success: false };
  }
};
